import { FC } from 'react';
import { Box } from '@mui/material';

interface IZoneCodeBadgeProps {
	code: string;
	size?: number;
}

export const ZoneCodeBadge: FC<IZoneCodeBadgeProps> = ({ code, size = 32 }) => {
	return (
		<Box
			sx={{
				width: size,
				height: size,
				borderRadius: '50%',
				bgcolor: 'ticketing.main',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				flexShrink: 0,
				color: 'common.white',
				fontFamily: '"Poppins", sans-serif',
				fontWeight: 600,
				fontSize: size >= 32 ? 20 : 14,
				lineHeight: 1.3,
			}}
		>
			{code}
		</Box>
	);
};
